import { Separator } from "@flight-tools/ui";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-border/40 bg-background/80 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-6">
        <Separator className="mb-6 opacity-30" />
        <div className="flex flex-col items-center justify-center gap-2 text-center text-sm text-muted-foreground">
          <p>© {currentYear} Herakles Analytics AB</p>
          <p className="text-xs opacity-70">
            Org. nr: 559448-3629 · Stockholm, Sweden
          </p>
        </div>
      </div>
    </footer>
  );
}
